/*global
    jQuery
*/
(function ($) {
    var showGuidance = $('span#show_guidance_p').length > 0;

    // Init GA for tracking outside of GTM
    if ( typeof ga !== 'undefined' ) {
        ga('create', 'UA-435081-12', 'auto');
    }

    var disableGuidance = function() {
        $.get('/mypets/turn-off-guidance', function(data, status) {
        });
    }

    var skipGuidanceInit = function() {
        var intro = introJs();
        intro.setOptions({
            doneLabel: 'Done',
            skipLabel: 'Close',
            showBullets: false,
            steps: [
                {
                    element: '#step4',
                    intro: 'You can always access the guided tour in your <b>Resources</b> tab under \'Start guided tour\'<br ><ul><li>How it works</li><li>FAQs</li><li>Help me keep my pet</li><li>Start guided tour</li></ul>'
                }
            ]
        }).start().onchange(function() {
            fireGAEvent(this._currentStep, this._direction);
        }).oncomplete(function() {
            if ( typeof ga !== 'undefined' ) {
                ga('send', 'event', 'Owner Guided Tour', 'Ended tour', 'Completed tour');
            }
        }).onexit(function() {
            if ( typeof ga !== 'undefined' ) {
                ga('send', 'event', 'Owner Guided Tour', 'Ended tour', 'Skipped to end of tour');
            }
        });
    }

    var guidanceInit = function() {
        if ( typeof ga !== 'undefined' ) {
            ga('send', 'event', 'Owner Guided Tour', 'Started tour', 'User started tour');
        }
        var intro = introJs();
        intro.setOptions({
            doneLabel: 'Done',
            skipLabel: 'Close',
            steps: [
                {
                    element: '#step1',
                    intro: 'Use <b>My Pets</b> to:<br ><ul><li>Edit and add details to your pet profile</li></ul>'
                },
                {
                    element: '#step2',
                    intro: 'Use <b>Inbox</b> to:<br ><ul><li>Respond to adopter questions</li><li>Review adopter applications</li></ul>'
                },
                {
                    element: '#step3',
                    intro: 'Use <b>Documents</b> to:<br ><ul><li>Upload any pet records</li><li>Submit adoption paperwork</li><li>View completed paperwork</li></ul>'
                },
                {
                    element: '#step4',
                    intro: 'Use <b>Resources</b> for helpful resources, tips, and content. Here you\'ll find:<br ><ul><li>How it works</li><li>FAQs</li><li>Help me keep my pet</li><li>Start guided tour</li></ul>'
                }
            ]
        }).start().onchange(function() {
            fireGAEvent(this._currentStep, this._direction);
        }).oncomplete(function() {
            if ( typeof ga !== 'undefined' ) {
                ga('send', 'event', 'Owner Guided Tour', 'Ended tour', 'Completed tour');
            }
        }).onexit(function() {
            if ( typeof ga !== 'undefined' ) {
                ga('send', 'event', 'Owner Guided Tour', 'Ended tour', 'Skipped to end of tour');
            }
        });
    }

    var fireGAEvent = function(step, direction) {
        if ( direction == 'forward' ) {
            var nextStep = parseInt(step) + 1;
            if ( typeof ga !== 'undefined' ) {
                ga('send', 'event', 'Owner Guided Tour', 'Step Clicked', 'Clicked Next to ' + nextStep);
            }
        } else {
            step = parseInt(step) + 2;
            var newStep = parseInt(step) - 1;
            if ( typeof ga !== 'undefined' ) {
                ga('send', 'event', 'Owner Guided Tour', 'Step Clicked', 'Clicked Back to ' + newStep);
            }
        }
    }

    if(typeof showGuidance !== 'undefined' && showGuidance && true == false) {
        $(window).on('load', function() {
            // Initialize the modal
            var $modal = $('[data-remodal-id=modal]');
            if (typeof $modal !== 'undefined' && $modal.length > 0 ) {
                var $modalInstance = $modal.remodal();
                $(document).on('confirmation', '.remodal', function() {
                    guidanceInit();
                });
                $(document).on('closed', '.remodal', function (e) {
                    if ( e.reason == undefined || e.reason == false || e.reason !== 'confirmation') {
                        skipGuidanceInit();
                    }
                });
                $modalInstance.open();
            }
            if (window.location.href.indexOf("/mypets?start_tour") > -1) {
                guidanceInit();
            }
        });
    }
}(jQuery));
